import React, { memo } from 'react'
import { Dialog, DialogTitle } from '@mui/material'

import Text from '../text/Text'
import CustomDialogContent from './CustomDialogContent'

const CustomDialog = ({
  banner,
  title,
  description,
  additionalDesc,
  open,
  onClose,
  onAutoClose,
  maxWidth,
  paperProps,
  isForm = false,
  ...restProps
}) => {
  return (
    <Dialog
      open={open}
      keepMounted
      onClose={onAutoClose}
      fullWidth
      PaperProps={{ sx: { borderRadius: '20px', ...paperProps } }}
      maxWidth={maxWidth}
    >
      {title && (
        <DialogTitle
          sx={{ p: 4, pb: 2, fontWeight: 800, fontSize: '1.25rem' }}
          variant='h4'
        >
          {title}
        </DialogTitle>
      )}
      {description && (
        <Text
          variant='body1'
          label={description}
          sx={{ pl: 4, pr: 4, fontSize: '1.125rem' }}
        />
      )}
      {additionalDesc}
      {banner}
      <CustomDialogContent onClose={onClose} isForm={isForm} {...restProps} />
    </Dialog>
  )
}

export default memo(CustomDialog)
